<template>
  <div>
    <div v-show="barShow" class="touchBar-blank" :style="blankStyle"></div>
    <div v-show="barShow" class="touchBar" :style="touchBarStyle">
      <div class="bar">
        <div class="left">
          <div class="logoBox">
            <div class="logo" :style="logoStyle" @click="goHome">
              <el-image :src="$domain.logo" />
            </div>
          </div>
          <div class="tab">
            <el-button
              v-for="(item, key) in navlist"
              :key="key"
              :style="tabStyle(item)"
              type="text"
              @click="btnNav(item)"
              @mouseout.native="hoverPath = ''"
              @mouseover.native="hoverPath = item.path"
            >
              {{ item.name }}
            </el-button>
            <!-- <el-popover placement="bottom" width="400" trigger="hover">
              <img src="../../assets/img/erweima.jpg" />
              <el-button
                class="appload"
                slot="reference"
                :style="tabStyle({ path: '/appdown' })"
                @mouseover.native="hoverPath = '/appdown'"
                @mouseout.native="hoverPath = ''"
                >APP下载</el-button
              >
            </el-popover> -->
          </div>
        </div>
        <div class="right">
          <!-- <el-popover placement="bottom" trigger="hover" width="200">
            <img
              :src="$common.getResourceUrl('appdown.jpg')"
              style="width: 100%; display: block"
            />
            <el-button
              slot="reference"
              class="app-down"
              style="top: 2px"
              type="text"
              >下载APP</el-button
            >
          </el-popover> -->

          <el-button
            v-if="!$store.state.userInfo"
            class="login-btn"
            plain
            :style="loginStyle"
            type="primary"
            @click="goLogin"
            >登录 / 注册</el-button
          >
          <el-dropdown
            v-else
            hide-on-click
            placement="bottom-end"
            size="medium"
            trigger="click"
            @command="userMenuClick"
          >
            <div class="listed">
              <div :style="{ color: textColor }">
                <img alt="" :src="$store.state.userInfo.headpic" />
                {{ $store.state.userInfo.nickname }}
              </div>
            </div>
            <!-- 下拉选择框 -->
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in userMenu"
                :key="index"
                :command="index"
                :divided="item.divided"
              >
                <span>{{ item.name }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const touchBarHeight = '66px'
export default {
  name: 'PageBar',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    blankShow: {
      type: Boolean,
      default: true,
    },
    transition: {
      type: Number,
      default: 0.5,
    },
    shadow: {
      type: String,
      default: '0px 0px 10px #eee',
    },
    bgColor: {
      type: String,
      default: 'transparent',
    },
    textColor: {
      type: String,
      default: '#444',
    },
    activeColor: {
      type: String,
      default: '#fff',
    },
    loginColor: {
      type: String,
      default: '#0e9fff',
    },
    logoBgColor: {
      type: String,
      default: 'transparent',
    },
  },
  data() {
    return {
      barHeight: touchBarHeight,
      barShow: this.show,
      hoverPath: '',
      navlist: [
        // {
        //   name: '首页',
        //   path: '/',
        // },
        // {
        //   name: '课程中心',
        //   path: '/course',
        // },
        // {
        //   name: '接单大厅',
        //   path: '/teacher',
        // },
        // {
        //   name: '素材中心',
        //   path: '/children',
        // },
        // {
        //   name: '新闻动态',
        //   path: '/children',
        // },
        // {
        //   name: '关于小白',
        //   path: '/about',
        // },
      ],
      opacitys: {
        background: 'rgba(255,255, 255,0) !important',
      },
      userMenu: [
        {
          name: '我的课架',
          path: '/myCourses',
        },
        {
          name: '我的订单',
          path: '/orderCenter',
        },
        {
          name: '我的作业',
          path: '/myTask',
        },
        {
          name: '我的服务',
          path: '/myService',
        },
        {
          name: '退出',
          path: this.logout,
          divided: true,
        },
      ],
    }
  },
  computed: {
    // 占位空间样式
    blankStyle() {
      const style = {}
      style.height = this.blankShow ? this.barHeight : '0'
      // style.transition = 'height 0.08s ease'
      return style
    },
    // 导航栏主体样式
    touchBarStyle() {
      const style = {}
      const isShowBg = this.bgColor && this.bgColor !== 'transparent'
      style.opacity = this.show ? '1' : '0'
      style.backgroundColor = isShowBg ? this.bgColor : 'transparent'
      style.color = this.textColor
      // style.boxShadow = isShowBg ? this.shadow : 'unset'
      style.borderBottom = isShowBg
        ? '0.5px solid #EAEAEA'
        : '0px solid transparent'
      style.transition = 'all ' + this.transition + 's ease'
      return style
    },
    // // logo切换
    // bgIMG() {
    //   const isShowBg = this.bgColor && this.bgColor !== 'transparent'
    //   const img = isShowBg
    //     ? this.$common.getResourceUrl('pcweb/logo_2.png')
    //     : this.$common.getResourceUrl('pcweb/logo_2.png')
    //   return img
    // },
    logoStyle() {
      const isShowBg = this.logoBgColor && this.logoBgColor !== 'transparent'
      const style = {}
      style.transition = 'all ' + this.transition + 's ease'
      if (isShowBg) {
        style.backgroundColor = this.logoBgColor
        style.width = '90%'
        style.height = '90%'
      } else {
        style.width = '100%'
        style.height = '100%'
      }
      return style
    },
    loginStyle() {
      const style = {
        color: this.loginColor,
        borderColor: this.loginColor,
      }
      style.transition = 'all ' + this.transition + 's ease'
      return style
    },
    // 选中标签样式
    tabStyle() {
      return (item) => {
        const style = {}
        if (
          item.path === this.$route.path ||
          this.$route.matched.find((i) => item.path === i.path)
        ) {
          style.color = this.activeColor
          style.fontWeight = this.activeColor ? '500' : '400'
          // style.borderTop = '3px solid ' + this.activeColor
        } else if (item.path === this.hoverPath) {
          style.color = this.activeColor
        } else {
          style.color = this.textColor
        }
        // 延迟渐变效果
        style.transition = 'all ' + this.transition + 's ease'
        return style
      }
    },
  },
  watch: {
    show(e) {
      setTimeout(() => {
        this.barShow = e
        this.barHeight = e ? touchBarHeight : '0'
      }, this.transition * 1000)
    },
  },
  mounted() {
    this.$store.dispatch('setUser')
  },
  methods: {
    // 跳转路由
    btnNav(item) {
      this.$router.push(item.path)
    },
    // 跳转首页
    goHome() {
      this.$router.push('/')
    },
    // 跳转登录页
    goLogin() {
      this.$store.dispatch('loginNext', () => {
        console.info(123123213123213123123)
      })
      // this.$router.push('/login')
    },
    // 下拉菜单跳转
    userMenuClick(index) {
      const path = this.userMenu[index].path
      if (typeof path === 'function') {
        path()
      } else {
        this.$router.push(path)
      }
    },
    logout() {
      window.localStorage.removeItem('user-token')
      this.$store.commit('setUser')
      if (this.$route.meta.needLogin) {
        this.$router.push({
          path: '/login',
          query: {
            url: this.$route.fullPath,
          },
        })
      }
    },
  },
}
</script>

<style>
body.el-popup-parent--hidden .touchBar {
  padding-right: 15px;
  width: calc(100% - 15px);
}
</style>
<style lang="scss" scope>
.touchBar-blank,
.touchBar {
  width: 100%;
}
.touchBar {
  position: fixed;
  top: 0;
  z-index: 999;
  box-sizing: content-box;
  transition-property: opacity, background-color, color, border-bottom, height !important;
}

.bar {
  display: flex;
  justify-content: space-between;
  height: 100%;
  max-width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
  .el-button {
    border: 0;
  }
  .appload:hover {
    background: none;
  }

  .left {
    flex: 1;
    display: flex;
    height: 100%;

    .logoBox {
      max-width: 180px;
      height: 100%;

      .logo {
        border-radius: 0 0 15px 15px;
        cursor: pointer;
        display: flex;
        align-items: center;

        .el-image {
          width: auto;
          height: 60%;
          border-radius: 0 0 8px 8px;
        }
      }
    }

    .tab {
      display: flex;
      height: 100%;
      margin-left: 100px;

      .el-button {
        box-sizing: border-box;
        margin-right: 42px;
        margin-left: 0;
        // width: 90px;
        height: 100%;
        border-radius: 0;
        background: none;
        font-size: 15px;
        font-weight: 400;

        &:focus,
        &:hover {
          color: unset;
        }
      }
    }
  }
  .right {
    display: flex;
    align-items: center;

    .app-down {
      margin-right: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #444444;
      position: relative;
    }
    .login-btn {
      background: none;
      border-radius: 6px;
      border: 1px solid #37a6ff;
      padding: 0;
      margin: 0;
      width: 98px;
      height: 36px;

      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #37a6ff;
      line-height: 34px;

      &:hover {
        background: rgba(18, 150, 255, 0.1);
      }
    }

    .listed {
      cursor: pointer;

      & > div {
        display: flex;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
          display: block;
          border-radius: 50%;
          border: solid 2px #ffffff;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
